<div *ngIf="show" class="contentLoader">
  <div style="margin-left: 250px">
    <!-- <fa-icon icon="spinner" [spin]="true"></fa-icon> -->
    <img src="./assets/img/Simbolodeespera1.gif" alt="" style="width: 150px" />
  </div>
</div>
